import { useCallback } from 'react';
import type { TranslationKey } from '../i18n/translation';
import { TRANSLATIONS } from '../i18n/translations';
import { useLanguage } from './use-language';

/**
 * Returns the active language and a lookup for it. The key is typed against the Kazakh reference
 * set, so a typo is a compile error rather than a dotted path rendered to a customer.
 */
export function useTranslation(): { t: (key: TranslationKey) => string; language: string } {
    const language = useLanguage();
    const strings = TRANSLATIONS[language];

    const t = useCallback((key: TranslationKey) => strings[key] ?? key, [strings]);

    return { t, language };
}
